export const FETCH_USER_ACTIVITY = `app/containers/UserActivity/FETCH_USER_ACTIVITY`
export const FETCH_USER_ACTIVITY_SUCCES = `app/containers/UserActivity/FETCH_USER_ACTIVITY_SUCCES`
export const FETCH_USER_ACTIVITY_ERROR = `app/containers/UserActivity/FETCH_USER_ACTIVITY_ERROR`

export const SET_FILTER_VALUES = `app/containers/UserActivity/SET_FILTER_VALUES`
